import { Component, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { QuestionFacade } from '../../facade/question.facade';
import { NgStyle, AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  imports: [NgStyle, AsyncPipe],
})
export class BreadcrumbComponent {
  private readonly questionFacade = inject(QuestionFacade);

  numberOfStepExecuted$: Observable<number>;
  numberOfSteps$: Observable<number>;

  constructor() {
    this.numberOfStepExecuted$ = this.questionFacade.findData((state) => state.numberOfStepExecuted);
    this.numberOfSteps$ = this.questionFacade.findData((state) => state.numberOfStep);
  }
}
